import {UI, styleRuleCustom, styleRuleInherit} from "../../stem-core/src/ui/UI";
import {App} from "../App";
import {GlobalStyleSheet} from "../GlobalStyleSheet";
import {Route, Router} from "../../stem-core/src/ui/Router";
import {iFrameConnection} from "../services/IFrameConnection";
import {IFrameMessages} from "../../blink-sdk/messaging/IFrameMessages";
import {iFrameState} from "../services/IFrameState";
import {
    LOGIN_WITH_EMAIL_CODE_URL,
    SIGNUP_EXTERNAL_URL,
    AUTH_MODAL_CLOSE_TIMEOUT
} from "../Constants";
import {authService, userService} from "../../client/connection/Services";

import {Theme} from "../../stem-core/src/ui/UI";
import {unwrapArray} from "../../stem-core/src/base/Utils";
import {PageTitleManager} from "../../stem-core/src/base/PageTitleManager";
import {
    FUNCTIONALITY_NOT_ENABLED_URL,
    INLINE_DONATION_URLS,
    INLINE_EDIT_DONATION_URLS,
    INLINE_EDIT_SUBSCRIPTION_URLS,
    INLINE_NEWSLETTER_URLS,
    INLINE_SUBSCRIPTION_URLS, INLINE_USER_DASHBOARD_URLS
} from "./PaywallConstants";
import {AuthSuccessSpinner} from "../website/unauthenticated/components/AuthSuccessSpinner";
import {isDeepEqual, setToastClass} from "../Utils";

import {Errors} from "../../client/connection/services/Errors";
import {
    AUTHENTICATION_PANEL_TYPE,
    PANEL_TYPE,
    PANEL_VARIANT,
    SOCIAL_APPS
} from "../../blink-sdk/Constants";
import {AuthorizationPanel} from "./pages/AuthorizeApplication";
import {AuthHelper} from "../AuthHelper";
import {Image} from "../../stem-core/src/ui/UIPrimitives";
import {LoadingSpinner} from "../ui/LoadingSpinner";
import {queueMicrotaskWrapper} from "../AsyncAggregateDispatcher";
import {supportsPassiveEvents} from "../../blink-sdk/utils/Utils";
import {DonateHomePage} from "./donate-page/DonateHomePage";
import {AdBlockerDonate} from "./inline-donation/AdBlockerDonate";
import {collapseIframe, collapseIframeAndExpandWallet} from "../widget/misc/WidgetUtils";
import {iFrameMerchantService} from "../services/IframeMerchantService";
import {iFrameUserDataService} from "../services/IFrameUserDataService";
import {DonationPanel} from "./pages/panels/donation/DonationPanel";
import {AuthenticationPanel} from "./pages/panels/AuthenticationPanel";
import {DonationAuthenticationPanel} from "./pages/panels/donation/DonationAuthenticationPanel";
import {EmailCodeConfirmationPanel} from "./pages/panels/EmailCodeConfirmationPanel";
import {DonatePanel} from "./pages/panels/donation/DonatePanel";
import {PaymentMethodPanel} from "./pages/panels/payment-method/PaymentMethodPanel";
import {DonationFailedPanel} from "./pages/panels/donation/DonationFailedPanel";
import {DonationSuccessPanel} from "./pages/panels/donation/DonationSuccessPanel";
import {EditDonationPanel} from "./pages/panels/donation/edit-donation/EditDonationPanel";
import {CancelDonationPanel} from "./pages/panels/donation/edit-donation/CancelDonationPanel";
import {DonationCanceledPanel} from "./pages/panels/donation/edit-donation/DonationCanceledPanel";
import {EditDonationSuccessPanel} from "./pages/panels/donation/edit-donation/EditDonationSuccessPanel";
import {SubscribePlanPanel} from "./pages/panels/subscribe/SubscribePlanPanel";
import {SubscribePanel} from "./pages/panels/subscribe/SubscribePanel";
import {SubscribeAuthenticationPanel} from "./pages/panels/subscribe/SubscribeAuthenticationPanel";
import {SubscribeReviewOrderPanel} from "./pages/panels/subscribe/SubscribeReviewOrderPanel";
import {SubscribeThankYouPanel} from "./pages/panels/subscribe/SubscribeThankYouPanel";
import {SubscribeFailedPanel} from "./pages/panels/subscribe/SubscribeFailedPanel";
import {donateMobileState} from "./inline-donation/DonateMobileState";
import {EditSubscriptionPanel} from "./pages/panels/subscribe/edit-subscription/EditSubscriptionPanel";
import {EditSubscriptionCancelPanel} from "./pages/panels/subscribe/edit-subscription/EditSubscriptionCancelPanel";
import {EditSubscriptionCancelSuccessPanel} from "./pages/panels/subscribe/edit-subscription/EditSubscriptionCancelSuccessPanel";
import {EditSubscriptionSuccessPanel} from "./pages/panels/subscribe/edit-subscription/EditSubscriptionSuccessPanel";
import {PaymentPanel} from "./pages/panels/payment/PaymentPanel";
import {CustomPanel} from "./pages/panels/CustomPanel";
import {AutopayThresholdExceededPanel} from "./pages/panels/payment/AutopayThresholdExceededPanel";
import {AutopayDisabledPanel} from "./pages/panels/payment/AutopayDisabledPanel";
import {InsufficientFundsPanel} from "./pages/panels/payment/InsufficientFundsPanel";
import {UnexpectedErrorPanel} from "./pages/panels/payment/UnexpectedErrorPanel";
import {PaymentAndDonationPanel} from "./pages/panels/donation/PaymentAndDonationPanel";
import {addThemeConstants} from "../StyleConstants";
import {CDSAuthenticationPanel} from "blinkpay/paywall/inline-subscription/auth/CDSAuthenticationPanel";
import {subscribeFlowState} from "./inline-subscription/SubscribeFlowState";
import {NewsletterPanel} from "./pages/panels/newsletter/NewsletterPanel";
import {NewsletterSubscribePanel} from "./pages/panels/newsletter/NewsletterSubscribePanel";
import {NewsletterSubscribeSuccessPanel} from "./pages/panels/newsletter/NewsletterSubscribeSuccessPanel";
import {InlineUserDashboard} from "./pages/inline-user-dashboard/InlineUserDashboard";
import {InlineUserDashboardRemoveCardPanel} from "./pages/inline-user-dashboard/prompt-panels/InlineUserDashboardRemoveCardPanel";
import {InlineUserDashboardCardInUsagePanel} from "./pages/inline-user-dashboard/prompt-panels/InlineUserDashboardCardInUsagePanel";
import {InlineUserDashboardChangeEmailCodeConfirmPanel} from "./pages/inline-user-dashboard/prompt-panels/InlineUserDashboardChangeEmailCodeConfirmPanel";
import {AddressPanel} from "./pages/panels/address/AddressPanel";
import {InlineUserDashboardRemoveAddressPanel} from "./pages/inline-user-dashboard/prompt-panels/InlineUserDashboardRemoveAddressPanel";
import {InlineUserDashboardAddressInUsePanel} from "./pages/inline-user-dashboard/prompt-panels/InlineUserDashboardAddressInUsePanel";
import {subscribePlanController} from "./inline-subscription/SubscribePlanController";
import {InlineUserDashboardSubscriptionChangeConfirmPanel} from "./pages/inline-user-dashboard/prompt-panels/InlineUserDashboardSubscriptionChangeConfirmPanel";
import {englishTranslationMap} from "../Messages";
import {apiConnection} from "../../client/connection/BlinkApiConnection";
import {GlobalState} from "../../stem-core/src/state/State";
import {iFrameAuthService, shiftToMerchantToken} from "../services/IFrameAuthService";
import {InlineUserDashboardSubscribeChangeSuccessPanel} from "./pages/inline-user-dashboard/prompt-panels/InlineUserDashboardSubscribeChangeSuccessPanel";
import {MerchantAudienceStore} from "../../client/state/merchant/MerchantAudienceStore";
import {FunctionalityNotEnabledPanel} from "./pages/panels/FunctionalityNotEnabledPanel";
import {PaywallToast} from "./PaywallToast";
import {ensureNaClScript} from "../../client/crypto/encryptJSON";


export class PaywallAppGlobalStyleSheet extends GlobalStyleSheet {
    @styleRuleCustom({selector: "body>div>div>div"})
    default5Child = {
        overflow: "hidden !important",
    };

    @styleRuleInherit
    html = {
        overflow: "hidden !important",
    };

    @styleRuleInherit
    a = {
        fontWeight: this.themeProps.MERCHANT_FONT_WEIGHT_BOLD,
    };

    @styleRuleInherit
    body = {
        color: this.themeProps.MERCHANT_TEXT_PRIMARY_COLOR,
        overflow: "hidden !important",
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_NORMAL,
        fontFamily: this.themeProps.MERCHANT_FONT_FAMILY,
        lineHeight: this.themeProps.GENERAL_LINE_HEIGHT,
        borderRadius: this.themeProps.MERCHANT_FRAME_BORDER_RADIUS,
        background: "transparent",
    };

    @styleRuleCustom({selector: "b"})
    b = {
        fontWeight: this.themeProps.MERCHANT_FONT_WEIGHT_BOLD,
    };

    @styleRuleInherit
    allInputs = {
        fontFamily: this.themeProps.MERCHANT_FONT_FAMILY,
    };
}

export class PaywallApp extends App {
    isAuthorizationPage = false;
    merchantFonts = [];

    applyMerchantTheme() {
        this.addMerchantFonts();
        addThemeConstants(iFrameState.theme);
    }

    applyMerchantMessages() {
        for (const [key, value] of Object.entries(iFrameState.messages)) {
            englishTranslationMap.set(key, value);
        }
    }

    unapplyMerchantTheme() {
        this.constructor.initializeTheme();
    }

    constructor(...args) {
        super(...args);

        setToastClass(PaywallToast);
        this.appConstructor();
        this.applyMerchantTheme();
        this.applyMerchantMessages();
        donateMobileState.init();
    }

    getPage() {
        if ((iFrameState.panelType === PANEL_TYPE.donation && !iFrameMerchantService.getMerchant().allowDonations)
            || (iFrameState.panelType === PANEL_TYPE.subscribe && !iFrameMerchantService.getMerchant().allowSubscriptions)
            || (iFrameState.panelType === PANEL_TYPE.newsletter && !iFrameMerchantService.getMerchant().allowEmailing)) {
            return FUNCTIONALITY_NOT_ENABLED_URL;
        }

        const variant = iFrameState.variant;

        if (iFrameState.isInlineDonationFlow()) {
            if (variant === PANEL_VARIANT.editRecurring) {
                return INLINE_EDIT_DONATION_URLS.donate;
            }
            if (variant === PANEL_VARIANT.skipCTA) {
                if (authService.isAuthenticated()) {
                    return INLINE_DONATION_URLS.donate;
                }
                return SIGNUP_EXTERNAL_URL;
            }
            return PANEL_TYPE.donation;
        }

        if (iFrameState.isInlineSubscriptionFlow()) {
            if (variant === PANEL_VARIANT.editRecurring) {
                return INLINE_EDIT_SUBSCRIPTION_URLS.subscribe;
            }
            if (variant === PANEL_VARIANT.skipCTA) {
                return SIGNUP_EXTERNAL_URL;
            }
            return INLINE_SUBSCRIPTION_URLS.subscriptionsOverview;
        }

        if (iFrameState.panelType === PANEL_TYPE.newsletter && variant === PANEL_VARIANT.skipCTA) {
            return INLINE_NEWSLETTER_URLS.subscribe;
        }

        if (iFrameState.panelType === PANEL_TYPE.dashboard && !authService.isAuthenticated()) {
            return SIGNUP_EXTERNAL_URL;
        }

        return iFrameState.panelType;
    }

    appConstructor() {
        const page = this.getPage();
        this.setupAuthHelper(page);

        this.initRouter(page);
    }

    initRouter(initialPage) {
        // The router in this app shouldn't alter the browser history.
        Router.useLocalHistory = true;
        Router.localHistory = [initialPage];
        Router.prototype.setURL = function (urlParts) {
            AuthSuccessSpinner.hide();

            urlParts = unwrapArray(urlParts);
            const page = this.getPageToRender(urlParts);

            if (!page) return;

            const activePage = this.getActive();

            if (activePage !== page) {
                activePage && activePage.dispatch("urlExit");
                queueMicrotaskWrapper(() => {
                    this.setActive(page);
                    page.dispatch("urlEnter");
                });
            } else {
                page.dispatch("urlReload");
            }

            iFrameConnection.sendToSDK(IFrameMessages.PAYWALL_CHANGE_ROUTE, {route: urlParts.join("/")});

            if (page && page.pageTitle) {
                PageTitleManager.setTitle(page.pageTitle);
            }

            this.dispatch("change", urlParts, page, activePage);
        }
    }

    addMerchantFonts() {
        const styleElement = document.createElement("style");
        for (const font of iFrameState.fonts) {
            if (!this.merchantFonts.find(f => isDeepEqual(f, font))) {
                const {family, style, src, weight, unicodeRange} = font;
                styleElement.appendChild(document.createTextNode(`
                @font-face{
                    font-family: ${family};
                    src: ${src};
                    ${style ? `font-style: ${style};` : ""}
                    ${weight ? `font-weight: ${weight};` : ""}
                    ${unicodeRange ? `unicode-range: ${unicodeRange}; ` : ""}
                }`));
                this.merchantFonts.push(font);
            }
        }
        if (styleElement.innerHTML.length) {
            document.head.appendChild(styleElement);
        }
    }

    static initializeGlobalStyle() {
        PaywallAppGlobalStyleSheet.initialize();
    }

    static addWsListener(streamName) {
        apiConnection.addWsListener(streamName, async event => {
            if (event.type === "logout") {
                if (iFrameAuthService.merchantToken) {
                    shiftToMerchantToken();
                } else {
                    authService.clearCurrentInfo();
                }
            } else {
                GlobalState.applyEvent(event);
            }
        });
    }

    getContainer() {
        return [
            <div style={{height: "100%"}}>
                {this.getRouter()}
                {this.getStaticInvisibleElements()}
            </div>,
        ];
    }

    // Render these invisible elements so the fetches execute earlier.
    getStaticInvisibleElements() {
        const merchant = iFrameMerchantService.getMerchant();

        // This is so that the elements are under no circumstance visible.
        return (
            <div style={{opacity: "0", pointerEvents: "none", zIndex: -1, position: "absolute", top: -1e4, left: -1e4}}>
                {merchant ? <Image src={merchant.wideLogoUrl}/> : null}
                <div style={{fontStyle: "italic"}}>a</div>
                <div style={{fontWeight: Theme.props.MERCHANT_FONT_WEIGHT_BOLD}}>a</div>
                <div>a</div>
            </div>
        );
    }

    getSubroutes() {
        // TODO: Try to move as many of these components to their own routes and discriminate
        //  by variant/authentication status in getPage() where possible.
        const getAuthPage = (...args) => {
            if (iFrameState.authSocialProviders.indexOf(SOCIAL_APPS.CDS) !== -1) {
                return new CDSAuthenticationPanel(...args);
            }
            if (iFrameState.isInlineDonationFlow()) {
                return new DonationAuthenticationPanel(...args);
            }
            if (iFrameState.isInlineSubscriptionFlow()) {
                return new SubscribeAuthenticationPanel(...args);
            }

            return new AuthenticationPanel(...args);
        };

        const authBeforeEnter = () => {
            if (this.isAuthorizationPage) {
                return;
            }
            if (iFrameState.isInlineDonationFlow()) {
                AuthHelper.addAuthenticationCallback(() => {
                    LoadingSpinner.show();
                    userService.ensureUserDataRequested(() => {
                        LoadingSpinner.hide();
                        if (iFrameUserDataService.getActiveRecurringDonation()) {
                            collapseIframeAndExpandWallet();
                        } else {
                            Router.changeURL(INLINE_DONATION_URLS.donate);
                        }
                    });
                });
                return;
            }
            if (iFrameState.isInlineSubscriptionFlow()) {
                AuthHelper.addAuthenticationCallback(() => {
                    LoadingSpinner.show();
                    userService.ensureUserDataRequested(() => {
                        LoadingSpinner.hide();
                        if (iFrameUserDataService.getActiveSubscription()) {
                            collapseIframeAndExpandWallet();
                        } else {
                            subscribePlanController.onSelectSuccess();
                        }
                    });
                });
                return;
            }
            if (iFrameState.panelType === PANEL_TYPE.dashboard) {
                AuthHelper.addAuthenticationCallback(() => {
                    LoadingSpinner.show();
                    userService.ensureUserDataRequested(() => {
                        LoadingSpinner.hide();
                        Router.changeURL(PANEL_TYPE.dashboard);
                    });
                });
                return;
            }
            if (authService.isAuthenticated()) {
                setTimeout(collapseIframe, AUTH_MODAL_CLOSE_TIMEOUT);
            }
            AuthHelper.addAuthenticationCallback(() => {
                LoadingSpinner.show();
                setTimeout(collapseIframe, AUTH_MODAL_CLOSE_TIMEOUT);
            });
        };

        const getDonatePage = (...args) => {
            if (donateMobileState.shouldRenderDonatePage()) {
                return new DonatePanel(...args);
            }
            return new PaymentAndDonationPanel(...args);
        };

        const getNewsletterPage = (...args) => {
            if (iFrameUserDataService.isUserSubscribedToAllGivenNewsletters()) {
                return new NewsletterSubscribeSuccessPanel(...args);
            }
            if (MerchantAudienceStore.all().length === 1) {
                return new NewsletterSubscribePanel(...args);
            }
            return new NewsletterPanel(...args);
        };

        const getDonationPage = (...args) => {
            if (iFrameState.variant === PANEL_VARIANT.adBlock) {
                return new AdBlockerDonate(...args); // TODO: Deprecated.
            }
            return new DonationPanel(...args);
        }

        const ensureNaClScriptForCDSPaymentPanel = () => {
            if (iFrameMerchantService.isCDSPaymentMethod()) {
                ensureNaClScript();
            }
        };
        const paymentMethodPanelOptions = {
            doNotCache: true,
            beforeEnter: ensureNaClScriptForCDSPaymentPanel,
        };

        return [
            new Route([SIGNUP_EXTERNAL_URL], getAuthPage, [], {beforeEnter: authBeforeEnter, doNotCache: true}),
            new Route([LOGIN_WITH_EMAIL_CODE_URL], EmailCodeConfirmationPanel),
            new Route([Errors.errorLinks.INSUFFICIENT_FUNDS], InsufficientFundsPanel),
            new Route([Errors.errorLinks.AUTO_PAY_DISABLED], AutopayDisabledPanel),
            new Route([Errors.errorLinks.AUTO_PAY_THRESHOLD_EXCEEDED], AutopayThresholdExceededPanel),
            new Route([Errors.errorLinks.UNEXPECTED_ERROR], UnexpectedErrorPanel),
            new Route([AUTHENTICATION_PANEL_TYPE], getAuthPage, [], {beforeEnter: authBeforeEnter, doNotCache: true}),
            new Route([FUNCTIONALITY_NOT_ENABLED_URL], FunctionalityNotEnabledPanel, {doNotCache: true}),
            new Route([PANEL_TYPE.donationPage], DonateHomePage),
            new Route([PANEL_TYPE.donation], getDonationPage),
            new Route([PANEL_TYPE.subscribe], SubscribePanel),
            new Route([PANEL_TYPE.payment], PaymentPanel),
            new Route([PANEL_TYPE.newsletter], getNewsletterPage),
            new Route([PANEL_TYPE.identity], AuthorizationPanel, [], {
                beforeEnter: () => {
                    if (!authService.isAuthenticated()) {
                        this.isAuthorizationPage = true;
                        AuthHelper.addAuthenticationCallback(() => {
                            Router.changeURL(PANEL_TYPE.identity);
                        });
                        return [SIGNUP_EXTERNAL_URL];
                    }
                    return null;
                }
            }),
            new Route([PANEL_TYPE.custom], CustomPanel),
            new Route([PANEL_TYPE.dashboard], InlineUserDashboard, [], {doNotCache: true}),
            new Route([INLINE_NEWSLETTER_URLS.subscribe], NewsletterSubscribePanel, [], {doNotCache: true}),
            new Route([INLINE_NEWSLETTER_URLS.success], NewsletterSubscribeSuccessPanel, [], {doNotCache: true}),
            new Route([INLINE_DONATION_URLS.donate], getDonatePage, {
                doNotCache: true,
                beforeEnter: ensureNaClScriptForCDSPaymentPanel,
            }),
            new Route([INLINE_DONATION_URLS.card], PaymentMethodPanel, [], paymentMethodPanelOptions),
            new Route([INLINE_DONATION_URLS.address], AddressPanel, {doNotCache: true}),
            new Route([INLINE_DONATION_URLS.thankYou], DonationSuccessPanel, [], {doNotCache: true}),
            new Route([INLINE_DONATION_URLS.failed], DonationFailedPanel),
            new Route([INLINE_EDIT_DONATION_URLS.donate], EditDonationPanel, [], {doNotCache: true}),
            new Route([INLINE_EDIT_DONATION_URLS.card], PaymentMethodPanel, [], paymentMethodPanelOptions),
            new Route([INLINE_EDIT_DONATION_URLS.thankYou], EditDonationSuccessPanel, [], {doNotCache: true}),
            new Route([INLINE_EDIT_DONATION_URLS.cancel], CancelDonationPanel),
            new Route([INLINE_EDIT_DONATION_URLS.cancelSuccess], DonationCanceledPanel),
            new Route([INLINE_SUBSCRIPTION_URLS.subscriptionsOverview], SubscribePlanPanel, [], {doNotCache: true}),
            new Route([INLINE_SUBSCRIPTION_URLS.address], AddressPanel), // TODO: If you don't cache this, the whole "addAddressAddedListener" logic fails. However, this should be fixed regardless.
            new Route([INLINE_SUBSCRIPTION_URLS.paymentDetails], PaymentMethodPanel, [], paymentMethodPanelOptions),
            new Route([INLINE_SUBSCRIPTION_URLS.subscriptionCheckout], SubscribeReviewOrderPanel, [], {doNotCache: true}),
            new Route([INLINE_SUBSCRIPTION_URLS.subscribeThankYou], SubscribeThankYouPanel, [], {doNotCache: true}),
            new Route([INLINE_SUBSCRIPTION_URLS.subscribeFailed], SubscribeFailedPanel, [], {doNotCache: true}),
            new Route([INLINE_EDIT_SUBSCRIPTION_URLS.subscribe], EditSubscriptionPanel, [], {doNotCache: true}),
            new Route([INLINE_EDIT_SUBSCRIPTION_URLS.changePlan], SubscribePlanPanel, [], {doNotCache: true}),
            new Route([INLINE_EDIT_SUBSCRIPTION_URLS.address], AddressPanel),
            new Route([INLINE_EDIT_SUBSCRIPTION_URLS.paymentDetails], PaymentMethodPanel, [], paymentMethodPanelOptions),
            new Route([INLINE_EDIT_SUBSCRIPTION_URLS.cancel], EditSubscriptionCancelPanel, [], {doNotCache: true}),
            new Route([INLINE_EDIT_SUBSCRIPTION_URLS.cancelSuccess], EditSubscriptionCancelSuccessPanel, [], {doNotCache: true}),
            new Route([INLINE_EDIT_SUBSCRIPTION_URLS.success], EditSubscriptionSuccessPanel, [], {doNotCache: true}),
            new Route([INLINE_USER_DASHBOARD_URLS.removeCard], InlineUserDashboardRemoveCardPanel, [], {doNotCache: true}),
            new Route([INLINE_USER_DASHBOARD_URLS.cardInUsage], InlineUserDashboardCardInUsagePanel, [], {doNotCache: true}),
            new Route([INLINE_USER_DASHBOARD_URLS.addPublicCard], PaymentMethodPanel, [], paymentMethodPanelOptions),
            new Route([INLINE_USER_DASHBOARD_URLS.addAddress], AddressPanel, [], {doNotCache: true}),
            new Route([INLINE_USER_DASHBOARD_URLS.editAddress], AddressPanel, [], {doNotCache: true}),
            new Route([INLINE_USER_DASHBOARD_URLS.removeAddress], InlineUserDashboardRemoveAddressPanel, [], {doNotCache: true}),
            new Route([INLINE_USER_DASHBOARD_URLS.addressInUsage], InlineUserDashboardAddressInUsePanel, [], {doNotCache: true}),
            new Route([INLINE_USER_DASHBOARD_URLS.editSubscriptionPaymentMethod], PaymentMethodPanel, [], paymentMethodPanelOptions),
            new Route([INLINE_USER_DASHBOARD_URLS.editSubscriptionAddress], AddressPanel, [], {doNotCache: true}),
            new Route([INLINE_USER_DASHBOARD_URLS.editSubscriptionPlan], SubscribePlanPanel, [], {doNotCache: true}),
            new Route([INLINE_USER_DASHBOARD_URLS.subscriptionChangeConfirm], InlineUserDashboardSubscriptionChangeConfirmPanel, [], {doNotCache: true}),
            new Route([INLINE_USER_DASHBOARD_URLS.subscriptionChangeSuccess], InlineUserDashboardSubscribeChangeSuccessPanel, [], {doNotCache: true}),
            new Route([INLINE_USER_DASHBOARD_URLS.changeEmailConfirmationCode], InlineUserDashboardChangeEmailCodeConfirmPanel, [], {doNotCache: true}),
        ];
    }

    getRoutes() {
        return new Route([], null, this.getSubroutes(), {});
    }

    setupAuthHelper(page) {
        AuthHelper.addAuthenticationCallback(() => {
            // TODO hack that needs to be reviewed and refactored
            // After authenticating on micro transaction merchants, don't
            // redirect back to PANEL_TYPE.payment, which is actually the authentication panel,
            // instead let the makePayment() logic do its job
            if (page === PANEL_TYPE.payment || page === PANEL_TYPE.donationPage) {
                return;
            }

            Router.changeURL(page);
        });
    }

    preventScrollPropagation() {
        const node = document.documentElement;
        node.setAttribute("tabindex", 0);

        const scrollEventOptions = supportsPassiveEvents() ? {passive: false} : false;

        node.addEventListener("wheel", e => e.stopPropagation(), scrollEventOptions);
        node.addEventListener("touchmove", e => e.stopPropagation(), scrollEventOptions);
    }

    onMount() {
        super.onMount();

        this.preventScrollPropagation();
        this.attachUpdateListener(iFrameState, () => {
            Theme.Global.updateStyleSheets();
            this.redraw();
        });

        iFrameConnection.addListener(IFrameMessages.PAYWALL_CHANGE_ROUTE, ({url}) => {
            donateMobileState.init(); // TODO(@branch): We need this, but not like this.
            subscribeFlowState.init(); // Same as above
            if (url) {
                Router.changeURL(url);
            } else {
                Router.changeURL(this.getPage());
            }
        });

        // TODO: Add auth change listener to properly redirect before components crash.
    }
}
